
const env = import.meta.env
export const ENV = env.VITE_BASE_ENV
export const PLATFORM = env.VITE_BASE_PLATFORM

export const LOGIN_SERVER: string = env.VITE_BASE_LOGIN_SERVER
export const COOKIE_DOMAIN: string = env.VITE_BASE_COOKIE_DOMAIN
export const SAAS_URL: string = env.VITE_BASE_SAAS_URL
export const SAAS_PC_URL: string = env.VITE_BASE_SAAS_URL_PC
export const LOGIN_URL: string = env.VITE_BASE_LOGIN_URL
export const THEME_COLOR: string = env.VITE_BASE_THEME_COLOR
export const PLATFORM_NAME:string = env.VITE_BASE_PLATFORM_NAME
export const API_DOMAIN:string = env.VITE_BASE_API_DOMAIN
export const STORE_DOMAIN:string = env.VITE_BASE_STORE_DOMAIN
export default {
    "login_server": env.VITE_BASE_LOGIN_SERVER,
    "wx_sao_server": env.VITE_BASE_WX_SAO_SERVER,
    "saas_url": env.VITE_BASE_SAAS_URL,
    "saas_url_pc": env.VITE_BASE_SAAS_URL_PC,
    "exchange_address": env.VITE_BASE_EXCHANGE_ADDRESS,
    "appid": env.VITE_BASE_APPID,
    "users_address": env.VITE_BASE_USERS_ADDRESS,
    'cookie_domain': env.VITE_BASE_COOKIE_DOMAIN,
    "captchaid": env.VITE_BASE_CAPTCHAID,
    "movie_qrcode": env.VITE_BASE_MOVIE_QRCODE,
    "user_account_serve": env.VITE_BASE_USER_ACCOUNT_SERVE,
    "api_domain": env.VITE_BASE_API_DOMAIN,
    "store_domain": env.VITE_BASE_STORE_DOMAIN,
    "env": env.VITE_BASE_ENV,
    'platform_name': env.VITE_BASE_PLATFORM_NAME,
    'platform': env.VITE_BASE_PLATFORM,
    'mall_domain': env.VITE_BASE_MALL_DOMAIN,
    'cas_api_domain': env.VITE_BASE_CAS_API_DOMAIN,
    'login_url': env.VITE_BASE_LOGIN_URL,
    'wx_login':env.VITE_BASE_WX_LOGIN,
    'lifeDomain': env.VITE_BASE_LIFE_DOMAIN,
    'authorized_to_login': env.VITE_BASE_LOGIN_AUTHORIZED,
    'neigou_link': env.VITE_BASE_NEIGOU_LINK,
    'movie_link': env.VITE_BASE_MOVIE_LINK,
    'hot_line': env.VITE_BASE_HOT_LINE,
    'hot_line_time':env.VITE_BASE_HOT_LINE_TIME
}
